import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../../dist/asyncToGenerator-9cc1acb2.esm.js';
import { _ as _objectSpread2 } from '../../../dist/objectSpread2-04e3d2b4.esm.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import Hls, { Events, ErrorTypes } from 'hls.js';
import { a as isClient } from '../../../dist/browser-30da4b11.esm.js';
import { n as noop } from '../../../dist/types-97851b96.esm.js';
import '../../../dist/defineProperty-6a97efcd.esm.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.number.constructor.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';

// deprecated! - all errors trigger exponential backoff
// keeping for documentation
//
// errors which trigger an exponential backoff
// const backoffRetryErrors = [
//   // custom error to indicate invalid JWT was provided
//   'Shutting down since this session is not allowed to view this stream',
//   // custom error to indicate stream could not be opened
//   'Stream open failed',
// ] as const;

var VIDEO_HLS_INITIALIZED_ATTRIBUTE = 'data-hls-initialized';
/**
 * Checks if hls.js can play in the browser.
 */
var isHlsSupported = function isHlsSupported() {
  return isClient() ? Hls.isSupported() : true;
};

/**
 * Create an hls.js instance and attach to the provided media element.
 */
var createNewHls = function createNewHls(source, element, callbacks, config) {
  // do not attach twice
  if (element.getAttribute(VIDEO_HLS_INITIALIZED_ATTRIBUTE) === 'true') {
    return {
      destroy: noop
    };
  }
  element.setAttribute(VIDEO_HLS_INITIALIZED_ATTRIBUTE, 'true');
  var hls = new Hls(_objectSpread2({
    maxBufferLength: 15,
    maxMaxBufferLength: 60
  }, config));
  var onDestroy = function onDestroy() {
    var _hls$destroy, _element$removeAttrib;
    hls === null || hls === void 0 ? void 0 : (_hls$destroy = hls.destroy) === null || _hls$destroy === void 0 ? void 0 : _hls$destroy.call(hls);
    element === null || element === void 0 ? void 0 : (_element$removeAttrib = element.removeAttribute) === null || _element$removeAttrib === void 0 ? void 0 : _element$removeAttrib.call(element, VIDEO_HLS_INITIALIZED_ATTRIBUTE);
  };
  if (element) {
    hls.attachMedia(element);
  }
  hls.on(Events.LEVEL_LOADED, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_e, data) {
      var _callbacks$onLive, _callbacks$onDuration;
      var _data$details, live, duration;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _data$details = data.details, live = _data$details.live, duration = _data$details.totalduration;
              callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onLive = callbacks.onLive) === null || _callbacks$onLive === void 0 ? void 0 : _callbacks$onLive.call(callbacks, Boolean(live));
              callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onDuration = callbacks.onDuration) === null || _callbacks$onDuration === void 0 ? void 0 : _callbacks$onDuration.call(callbacks, duration !== null && duration !== void 0 ? duration : 0);
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  hls.on(Events.MEDIA_ATTACHED, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            hls.loadSource(source);
            hls.on(Events.MANIFEST_PARSED, function (_event, _data) {
              var _callbacks$onCanPlay;
              callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onCanPlay = callbacks.onCanPlay) === null || _callbacks$onCanPlay === void 0 ? void 0 : _callbacks$onCanPlay.call(callbacks);
              if (config !== null && config !== void 0 && config.autoplay && element) {
                try {
                  element.muted = true;
                } catch (e) {
                  console.log('Unable to autoplay prior to user interaction with the dom.');
                }
              }
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
  var retryCount = 0;
  hls.on(Events.ERROR, /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_event, data) {
      var _callbacks$onError;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!data.fatal) {
                _context3.next = 15;
                break;
              }
              callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onError = callbacks.onError) === null || _callbacks$onError === void 0 ? void 0 : _callbacks$onError.call(callbacks, data);
              _context3.t0 = data.type;
              _context3.next = _context3.t0 === ErrorTypes.NETWORK_ERROR ? 5 : _context3.t0 === ErrorTypes.MEDIA_ERROR ? 9 : 13;
              break;
            case 5:
              _context3.next = 7;
              return new Promise(function (r) {
                return setTimeout(r, 1000 * ++retryCount);
              });
            case 7:
              hls === null || hls === void 0 ? void 0 : hls.recoverMediaError();
              return _context3.abrupt("break", 15);
            case 9:
              _context3.next = 11;
              return new Promise(function (r) {
                return setTimeout(r, 1000 * ++retryCount);
              });
            case 11:
              hls === null || hls === void 0 ? void 0 : hls.recoverMediaError();
              return _context3.abrupt("break", 15);
            case 13:
              onDestroy();
              return _context3.abrupt("break", 15);
            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }());
  return {
    destroy: onDestroy
  };
};

export { VIDEO_HLS_INITIALIZED_ATTRIBUTE, createNewHls, isHlsSupported };
